/**
 * What a rating is drawn as.
 *
 * Shared by the cell and the editor, which draw the same symbols in the same
 * colour and differ only in whether they can be pressed. Two copies of the icon
 * table would be two places for a rating to look like something else once it
 * was being edited.
 */
import { Flag, Heart, Smile, Star, ThumbsUp, type LucideIcon } from 'lucide-react'

import type { Field } from '@/api/types'
import { ratingStyleOf, type RatingStyle } from '../rating'

const RATING_ICONS = {
  star: Star,
  heart: Heart,
  'thumbs-up': ThumbsUp,
  flag: Flag,
  smile: Smile,
} as const satisfies Record<RatingStyle, LucideIcon>

/** The symbol one of the five styles is drawn with. */
export function iconForStyle(style: RatingStyle): LucideIcon {
  return RATING_ICONS[style]
}

/** The symbol a field is drawn with. */
export function ratingIcon(field: Field): LucideIcon {
  return RATING_ICONS[ratingStyleOf(field)]
}
